<template>
  <div class="pdv-address-form">
    <el-divider content-position="left">Localizar remetente</el-divider>
    <el-form
      ref="form"
      :model="ruleForm"
      :label-position="labelPosition"
      label-width="120px"
    >
      <el-row :gutter="12" class="pdv-form-row">
        <el-form-item
          class="no-margin-bottom"
          :label="$t('remetente')"
          prop="sender"
        >
          <el-row class="delivery-selector-row">
            <el-col class="delivery-selector-col">
              <SenderList
                ref="senderList"
                v-model="ruleForm.sender"
                :customer="ruleForm.licence"
                v-on:clear="clear"
              />
            </el-col>
            <el-col class="delivery-save-col">
              <el-button class="delivery-save-button" type="primary" title="Salva o remetente no sistema" @click="save()">
                <i class="fa fa-floppy-o" aria-hidden="true"></i>
                Salvar
              </el-button>
            </el-col>
          </el-row>
        </el-form-item>
      </el-row>

      <el-divider content-position="left">Dados do remetente</el-divider>

      <el-row :gutter="12" class="pdv-form-row">
        <el-col :xs="24" :sm="12" :md="8" :lg="7" :xl="6">
          <el-form-item
            :label="$t('cpf/cnpj')"
            prop="federalid"
            class="is-required"
          >
            <el-input
              v-model="ruleForm.federalid"
              v-mask="['NNN.NNN.NNN-NN', 'NN.NNN.NNN/NNNN-##']"
              v-on:keyup.native.enter="next"
              ref="federalid"
              data-next="contact"
            ></el-input>
          </el-form-item>
        </el-col>

        <el-col :xs="24" :sm="12" :md="16" :lg="17" :xl="18">
          <el-form-item :label="$t('nome')" prop="contact" class="is-required">
            <el-input
              v-model="ruleForm.contact"
              v-on:keyup.native.enter="next"
              ref="contact"
              data-next="zipcode"
              maxlength="50"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="12" class="pdv-form-row">
        <el-col :xs="24" :sm="12" :md="8" :lg="7" :xl="6">
          <el-form-item :label="$t('cep')" prop="cep" class="is-required">
            <el-input
              maxlength="9"
              v-model="ruleForm.cep"
              v-mask="'#####-###'"
              @blur="zipcode(ruleForm)"
              v-on:keyup.native.enter="next"
              ref="zipcode"
              data-next="address"
            ></el-input>
          </el-form-item>
        </el-col>

        <el-col :xs="24" :sm="12" :md="10" :lg="12" :xl="14">
          <el-form-item :label="$t('endereco')" prop="address">
            <el-input
              v-model="ruleForm.address"
              v-on:keyup.native.enter="next"
              data-next="number"
              ref="address"
              maxlength="50"
            ></el-input>
          </el-form-item>
        </el-col>

        <el-col :xs="24" :sm="12" :md="6" :lg="5" :xl="4">
          <el-form-item
            :label="$t('numero')"
            prop="number"
            ref="number"
            class="is-required"
          >
            <el-input
              maxlength="5"
              v-model="ruleForm.number"
              v-mask="'#####'"
              v-on:keyup.native.enter="next"
              data-next="neighborhood"
              ref="number"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="12" class="pdv-form-row">
        <el-col :xs="24" :sm="12" :md="12" :lg="7" :xl="6">
          <el-form-item :label="$t('bairro')" prop="neighborhood">
            <el-input
              v-on:keyup.native.enter="next"
              ref="neighborhood"
              data-next="city"
              v-model="ruleForm.neighborhood"
              maxlength="40"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="7">
          <el-form-item :label="$t('cidade')" prop="city">
            <el-input
              v-model="ruleForm.city"
              v-on:keyup.native.enter="next"
              ref="city"
              data-next="state"
              maxlength="40"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="8" :md="12" :lg="4" :xl="4">
          <el-form-item :label="$t('estado')" prop="state">
            <el-input
              v-model="ruleForm.state"
              maxlength="2"
              v-on:keyup.native.enter="next"
              data-next="extent"
              ref="state"
            ></el-input>
          </el-form-item>
        </el-col>

        <el-col :xs="24" :sm="16" :md="12" :lg="5" :xl="7">
          <el-form-item :label="$t('complemento')" prop="extent">
            <el-input
              v-model="ruleForm.extent"
              maxlength="40"
              v-on:keyup.native.enter="next"
              ref="extent"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>
<script>
import { i18n } from "@/plugin/i18n";
import { CustomerService } from "@/services/customers/customers.services";
import SenderList from "@/xpost/views/register/sender/SenderList";
import { SendersService } from "@/services/senders/senders.services";
import ZipMixins from "@/xpost/mixins/zipcode";
export default {
  mixins: [ZipMixins],
  name: "PdvCallDelivery",
  props: ["customer", "labelPosition", "licence"],
  components: {
    SenderList,
  },
  data() {
    return {
      userType: "3",
      ruleForm: {
        customer: "",
        contact: "",
        licence: "",
        federalid: "",
        cep: "",
        address: "",
        neighborhood: "",
        state: "",
        city: "",
        number: "",
        extent: "",
      },
    };
  },
  watch: {
    customer: function (v) {
      const vm = this;
      vm.fetchCustomer();
    },
    licence: function (v) {
      const vm = this;
      if (v) {
        vm.ruleForm.licence = v.id || v;
        console.log("mount sender", vm.ruleForm.licence, v);
        vm.$refs.senderList.fetchSenders(v.id || v);
      }
    },
    "ruleForm.sender": function (newVal, oldVal) {
      const vm = this;
      vm.fetchSender();
    },
  },
  methods: {
    startup(form) {
      this.ruleForm = form;
    },
    enter() {
      this.$refs.federalid.$el.getElementsByTagName("input")[0].select();
    },
    focus() {
      setTimeout(() => {
        this.$refs.federalid.focus();
      }, 200);
    },
    clear() {
      const vm = this;
      setTimeout(() => {
        if (vm.customer && vm.customer.id) {
          vm.ruleForm.customer = vm.customer.id;
        }
        vm.ruleForm.address = "";
        vm.ruleForm.contact = "";
        vm.ruleForm.cep = "";
        vm.ruleForm.city = "";
        vm.ruleForm.neighborhood = "";
        vm.ruleForm.state = "";
        vm.ruleForm.number = "";
        vm.ruleForm.extent = "";
        vm.ruleForm.federalid = "";
      }, 200);
    },
    validate() {
      const vm = this;
      return (
        vm.ruleForm.cep &&
        vm.ruleForm.address &&
        vm.ruleForm.neighborhood &&
        vm.ruleForm.city &&
        vm.ruleForm.state &&
        vm.ruleForm.contact &&
        vm.ruleForm.number
      );
    },
    next(el, ev) {
      if (el.target.dataset.next && this.$refs[el.target.dataset.next]) {
        this.$refs[el.target.dataset.next].$el
          .getElementsByTagName("input")[0]
          .select();
      } else {
        this.$emit("focus", "deliveryData");
      }
    },
    fetchSender() {
      const vm = this;
      if (!vm.ruleForm.sender) {
        return false;
      }
      SendersService.get(vm.ruleForm.sender)
        .then((response) => {
          vm.ruleForm.cep = response.zipcode;
          vm.ruleForm.contact = response.name;
          vm.ruleForm.address = response.address;
          vm.ruleForm.neighborhood = response.neighborhood;
          vm.ruleForm.city = response.city;
          vm.ruleForm.federalid = response.federalId;
          vm.ruleForm.state = response.state;
          vm.ruleForm.number = response.number;
          vm.ruleForm.extent = response.complement;
        })
        .catch((error) => {
          this.$message({
            type: "error",
            message: error,
          });
        });
    },
    fetchCustomer() {
      const vm = this;
      if (!vm.$props.customer) {
        return false;
      }
      CustomerService.get(vm.$props.customer.id)
        .then((response) => {
          if (response.cardpost && response.cardpost.length == 0) {
            this.$message({
              type: "warning",
              message: "Cliente sem cartão de postagem relacionado!",
              duration: 5000,
            });
          }
        })
        .catch((error) => {
          this.$message({
            type: "error",
            duration: 5000,
            message: error,
          });
        })
        .finally(() => (vm.loading = false));
    },
    save() {
      const vm = this;
      const loading = vm.$loading(vm.$options.loading);
      SendersService.add({
        customer: vm.customer.id,
        name: vm.ruleForm.contact,
        federalId: vm.ruleForm.federalid,
        zipcode: vm.ruleForm.cep,
        address: vm.ruleForm.address,
        neighborhood: vm.ruleForm.neighborhood,
        city: vm.ruleForm.city,
        state: vm.ruleForm.state,
        number: vm.ruleForm.number,
        complement: vm.ruleForm.extent,
      })
        .then((response) => {
          if (vm.$refs.senderList) vm.$refs.senderList.fetchSenders();
          this.$message({
            type: "success",
            message: i18n.tc("remetente-criado-sucesso"),
            duration: 5000,
          });
        })
        .catch((error) => {
          this.$message({
            type: "error",
            message: error,
            duration: 5000,
          });
        })
        .finally(() => loading.close());
    },
  },
  mounted() {
    const vm = this;
    setTimeout(() => {
      if (vm.customer && vm.customer.id) {
        vm.ruleForm.customer = vm.customer.id;
      }
      if (vm.licence && vm.licence.id) {
        vm.ruleForm.licence = vm.licence.id;
      }
      vm.ruleForm.address = "";
      vm.ruleForm.cep = "";
      vm.ruleForm.city = "";
      vm.ruleForm.neighborhood = "";
      vm.ruleForm.state = "";
      vm.ruleForm.number = "";
      vm.ruleForm.extent = "";
      vm.ruleForm.federalid = "";
      console.log("vm.customer sender", vm.customer, vm.ruleForm.licence);
    }, 200);
  },
};
</script>
<style scoped>
.pdv-address-form {
  width: 100%;
}

.pdv-form-row {
  margin-bottom: 12px;
}

.pdv-address-form >>> .el-select,
.pdv-address-form >>> .el-input {
  width: 100%;
}

.bottom {
  margin-top: 8px;
}

.delivery-selector-row {
  align-items: center;
  display: flex;
  gap: 12px;
  width: 100%;
}

.delivery-selector-col {
  flex: 1 1 auto;
  float: none;
  min-width: 0;
}

.delivery-save-col {
  flex: 0 0 110px;
  float: none;
  max-width: 110px;
}

.delivery-save-button {
  width: 100%;
}

@media (max-width: 767px) {
  .pdv-form-row {
    margin-bottom: 0;
  }

  .delivery-selector-row {
    align-items: stretch;
    flex-direction: column;
  }

  .delivery-save-col {
    flex-basis: auto;
    max-width: none;
    width: 100%;
  }
}
</style>
